import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SkeletonModule } from 'primeng/skeleton';

import { CheckboxModule } from '@appkit4/angular-components/checkbox';
import { PaginationModule } from '@appkit4/angular-components/pagination';
import { SearchModule } from '@appkit4/angular-components/search';
import { TableModule } from '@appkit4/angular-components/table';
import { SharedModule } from '@shared/shared.module';
import { TableModule as PrimerTableModule } from 'primeng/table';
import { PrimeGridFiltersModule } from '../prime-grid-filters/prime-grid-filters.module';

import { GridRowIteratorPipe } from './pipes/grid-row-iterator.pipe';

import { CardsGridComponent } from './components/cards-grid/cards-grid.component';
import { GridCrudButtonsComponent } from './components/grid-crud-buttons/grid-crud-buttons.component';
import { GridFooterComponent } from './components/grid-footer/grid-footer.component';
import { GridHeaderComponent } from './components/grid-header/grid-header.component';
import { GridComponent } from './components/grid/grid.component';
import { PrimeGridHeaderComponent } from './components/prime-grid-header/prime-grid-header.component';
import { PrimeGridComponent } from './components/prime-grid/prime-grid.component';

import { GridTemplateFactoryComponent } from './components/grid-template-factory/grid-template-factory.component';
import { PrimeGridAccordionButtonComponent } from './components/prime-grid-accordion-button/prime-grid-accordion-button.component';
import { PrimeGridRowAccordionDirective } from './directives/prime-grid-row-accordion.directive';
import { GridQueryBuilderService } from './services/grid-query-builder.service';
import { PrimeGridFilterBuilderService } from './services/prime-grid-filter-builder.service';
import { TableDataSortManagerService } from './services/table-data-sort-manager.service';

const pipes = [GridRowIteratorPipe];

const directives = [PrimeGridRowAccordionDirective];

@NgModule({
  declarations: [
    ...pipes,
    ...directives,
    GridFooterComponent,
    GridHeaderComponent,
    GridCrudButtonsComponent,
    PrimeGridHeaderComponent,
    GridTemplateFactoryComponent,
    PrimeGridComponent,
    GridComponent,
    CardsGridComponent,
    PrimeGridAccordionButtonComponent,
  ],
  imports: [
    CommonModule,
    TableModule,
    SearchModule,
    CheckboxModule,
    PaginationModule,
    PrimerTableModule,
    SharedModule,
    PrimeGridFiltersModule,
    SkeletonModule,
  ],
  providers: [
    TableDataSortManagerService,
    PrimeGridFilterBuilderService,
    GridQueryBuilderService,
  ],
  exports: [
    PrimeGridComponent,
    GridComponent,
    GridFooterComponent,
    CardsGridComponent,
  ],
})
export class GridModule {}
